import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { SKILLS } from './constants';
import { SectionContainer, Container, SectionHeader, SectionTitle, WordCloudContainer, WordCloud, SkillTag, } from './Skills.styles';
const Skills = () => {
    const cloudRef = useRef(null);
    const observerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const hasAnimatedRef = useRef(false);
    useEffect(() => {
        if (!cloudRef.current)
            return;
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px',
        };
        observerRef.current = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !hasAnimatedRef.current) {
                    hasAnimatedRef.current = true;
                    // Use requestAnimationFrame to ensure DOM is ready
                    requestAnimationFrame(() => {
                        setIsVisible(true);
                    });
                }
            });
        }, observerOptions);
        if (cloudRef.current) {
            observerRef.current.observe(cloudRef.current);
        }
        return () => {
            if (observerRef.current)
                observerRef.current.disconnect();
        };
    }, []);
    // Keep skills in original order for stability
    const orderedSkills = SKILLS;
    return (_jsxs(SectionContainer, { id: "skills", children: [_jsx(Container, { children: _jsx(SectionHeader, { children: _jsx(SectionTitle, { children: "Skills" }) }) }), _jsx(WordCloudContainer, { children: _jsx(WordCloud, { ref: cloudRef, children: orderedSkills.map((skill, index) => (_jsx(SkillTag, { "$size": skill.size, "$category": skill.category, "$visible": isVisible, "$index": index, children: skill.name }, `${skill.name}-${skill.category}-${skill.size}`))) }) })] }));
};
export default Skills;
